(function () {
  'use strict';

  if (window.FellinoraVipAutoCtaLoaded) {
    return;
  }

  window.FellinoraVipAutoCtaLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSection(section) {
    var items = section.querySelectorAll('[data-fvac-reveal]');

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('fvac-is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('fvac-is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -10% 0px'
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function init() {
    document.querySelectorAll('[data-fvac-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-fvac-section]');

    if (section) {
      initSection(section);
    }
  });
})();
